import { Balance, BalanceAccount, networkLabel } from "rujira.js";
import { nFormatter } from "../../helpers";
import { NetworkIcon } from "../icons/NetworkIcon";
import { Decimal } from "../numbers/Decimal";

type OmniBalanceProps = {
  onClick?: (b: Balance | BalanceAccount) => void;
  className?: string;
  balance?: Balance;
};

export const OmniBalance = ({
  balance,
  onClick,
  className,
}: OmniBalanceProps) => {
  return (
    <div className="omni-balance">
      <Decimal
        amount={balance?.balance || 0n}
        className={className}
        onClick={() => balance && onClick?.(balance)}
      />
      {balance?.accounts && balance.accounts.length > 1 && (
        <div className="omni-balance__networks">
          {balance.accounts &&
            balance.accounts.map((x) => {
              const n = x.asset.type === "SECURED" ? "THOR" : x.asset.chain;
              return (
                <button
                  key={n}
                  data-tooltip-id="global-tip"
                  data-tooltip-html={`
                    <div class="condensed fs-16 fw-500">${nFormatter(x.balance, 6)}</div><div class="fs-14 lh-16 color-grey">on ${networkLabel(
                      n
                    )}</div>`}
                  className={`omni-balance__network-button omni-balance__network-button--${n.toLowerCase()}`}
                  onClick={() => onClick?.(x)}>
                  <NetworkIcon network={n} />
                </button>
              );
            })}
        </div>
      )}
    </div>
  );
};
